(function () {
  'use strict';
  function chapterAt(tops, line) {
    return Math.max(0, tops.reduce((active, top, index) => top <= line ? index : active, 0));
  }
  function shelfProducts(mode) {
    return mode === 'evening' ? ['bright-start', 'stay-soft'] : mode === 'extras' ? ['face-mist', 'glow-hour'] : ['bright-start', 'stay-soft', 'sun-kissed'];
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { chapterAt, shelfProducts };
  if (typeof document === 'undefined') return;
  const layerCopy = [
    ['The outer welcome desk.', 'The epidermis is your outer skin layer. Its very top surface contains the barrier that helps keep moisture in and unwanted things out.'],
    ['A little strength. A lot of support.', 'Below the epidermis, the dermis contains collagen, elastin, blood vessels and nerves. It gives skin support and helps you sense the world.'],
    ['Your soft landing.', 'The hypodermis sits beneath the skin. Fat and connective tissue help cushion your body and provide insulation.']
  ];
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const chapters = [...root.querySelectorAll('[data-chapter]')];
    const links = [...root.querySelectorAll('.sw-timeline li a')];
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0, current = -1;
    function update() {
      frame = 0;
      const header = document.querySelector('header-component');
      const headerRect = header?.getBoundingClientRect();
      const headerHeight = headerRect && headerRect.top <= 0 && headerRect.bottom > 0 ? headerRect.bottom : 0;
      root.style.setProperty('--sw-header-height', headerHeight + 'px');
      const line = Math.max(headerHeight + 110, Math.min(240, innerHeight * .35));
      const rects = chapters.map(el => el.getBoundingClientRect());
      const next = chapterAt(rects.map(rect => rect.top), line);
      if (next !== current) {
        links.forEach((link, index) => index === next ? link.setAttribute('aria-current', 'step') : link.removeAttribute('aria-current'));
        current = next;
        root.querySelector('.sw-timeline-title').textContent = links[next].textContent.trim();
      }
      const total = rects[rects.length - 1].bottom - rects[0].top - innerHeight * .5;
      root.style.setProperty('--progress', Math.max(0, Math.min(1, (line - rects[0].top) / Math.max(1, total))));
      if (!reduce.matches) chapters.forEach((el, i) => {
        if (rects[i].bottom > 0 && rects[i].top < innerHeight) el.style.setProperty('--scene-progress', Math.max(0, Math.min(1, (innerHeight - rects[i].top) / (innerHeight + rects[i].height))));
      });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    reduce.addEventListener('change', schedule, { signal });
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    // Native anchors preserve keyboard focus, history and browser scrolling preferences.
    root.querySelectorAll('[data-layer]').forEach(button => button.addEventListener('click', () => {
      const index = Number(button.dataset.layer);
      root.querySelectorAll('[data-layer]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      root.querySelector('[data-layer-art]').dataset.activeLayer = String(index);
      const copy = root.querySelector('[data-layer-copy]');
      copy.querySelector('h3').textContent = layerCopy[index][0];
      copy.querySelector('p').textContent = layerCopy[index][1];
    }, { signal }));
    root.querySelectorAll('[data-barrier]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-barrier]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      root.querySelector('[data-barrier-art]').dataset.barrierArt = button.dataset.barrier;
      root.querySelector('[data-barrier-copy]').textContent = button.dataset.barrier === 'lipids' ? 'The “mortar”: lipids sit between cells and help limit water loss. Ceramides are one type of these natural fats.' : 'The “bricks”: flattened cells form the outermost surface.';
    }, { signal }));
    root.querySelectorAll('[data-learning-shelf]').forEach(shelf => {
      shelf.querySelectorAll('[data-shelf-mode]').forEach(button => button.addEventListener('click', () => {
        const mode = button.dataset.shelfMode;
        shelf.querySelectorAll('[data-shelf-mode]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
        shelf.querySelectorAll('[data-shelf-product]').forEach(el => { el.hidden = !shelfProducts(mode).includes(el.dataset.shelfProduct); });
        shelf.querySelector('[data-shelf-note]').textContent = mode === 'evening' ? 'Cleanse → moisturise. A soft landing at the end of your day.' : mode === 'extras' ? 'A little extra, only when you want it. These don’t replace your daily basics.' : 'Cleanse → moisturise → protect. Your morning, made simple.';
        schedule();
      }, { signal }));
    });
    update();
    const observer = new ResizeObserver(schedule);
    observer.observe(root);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); }
    }, { signal });
  }
  document.querySelectorAll('[data-skin-world]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-skin-world]').forEach(init));
})();
